import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from 'src/styles/theme';

const Heading = styled('h3')`
    margin: 0;
    padding: 0;
    margin-top: 40px;
    font-weight: 300;
    line-height: 1.41em;

    ${theme.fontSize.sans.mobile._24};
    ${theme.fontSize.sans.tablet._24};
    ${theme.fontSize.sans.desktop._24};
`;

const HeadingLevelThree = ({ children }) => <Heading>{children}</Heading>;

HeadingLevelThree.propTypes = {
    children: PropTypes.node.isRequired,
};

export default HeadingLevelThree;